import React from 'react';
import { parseAdvanceBookingMinInput } from '../../utils/advance-booking-days.util';

type AdvanceBookingDaysValue = { min: number; max: number };

interface AdvanceBookingDaysFieldsProps {
  value: AdvanceBookingDaysValue;
  onChange: (next: AdvanceBookingDaysValue) => void;
  allowNegativeMin?: boolean;
  minLabel?: string;
  maxLabel?: string;
  className?: string;
}

export const AdvanceBookingDaysFields: React.FC<AdvanceBookingDaysFieldsProps> = ({
  value,
  onChange,
  allowNegativeMin = false,
  minLabel = 'Đặt trước tối thiểu (ngày)',
  maxLabel = 'Đặt trước tối đa (ngày)',
  className = '',
}) => (
  <div className={`grid grid-cols-1 md:grid-cols-2 gap-6 ${className}`}>
    <div>
      <label className="block text-sm font-medium text-gray-700 mb-2">{minLabel}</label>
      <input
        type="number"
        value={value.min}
        onChange={(e) =>
          onChange({
            ...value,
            min: parseAdvanceBookingMinInput(e.target.value, 0),
          })
        }
        className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
        min={allowNegativeMin ? undefined : 0}
      />
      {allowNegativeMin ? (
        <p className="mt-1 text-xs text-gray-500">
          Có thể nhập số âm (ví dụ -3) để nhân viên đăng ký bù ngày đã qua.
        </p>
      ) : (
        <p className="mt-1 text-xs text-gray-500">0 = có thể chọn hôm nay.</p>
      )}
    </div>
    <div>
      <label className="block text-sm font-medium text-gray-700 mb-2">{maxLabel}</label>
      <input
        type="number"
        value={value.max}
        onChange={(e) =>
          onChange({
            ...value,
            max: parseInt(e.target.value, 10) || 7,
          })
        }
        className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
        min="1"
        max="365"
      />
    </div>
  </div>
);

export default AdvanceBookingDaysFields;
